import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  optionRow: {
    display: 'flex',
    alignItems: 'center',
  },
  orIcon: {
    width: theme.spacing(3),
    minWidth: theme.spacing(3),
    height: 'auto',
    marginRight: theme.spacing(1),
    display: 'flex',
  },
  orImg: {
    width: '100%',
    height: '100%',
  },
  orName: {
    fontFamily: 'Roboto',
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.grey[600],
    textDecoration: 'none',
    lineHeight: theme.spacing(2.5),
  },
  optionLink: {
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
  },
}));

const FiltersRenderedOption = ({ option }) => {
  const classes = useStyles();
  return (
    <div
      className={classes.optionRow}
      data-testid="es-mr-vehicle-type-option"
      data-type-name={option.name || ''}
    >
      <a href={option.url} onClick={(e) => e.preventDefault()} className={classes.optionLink}>
        <div className={classes.orIcon}>
          {(option.image_url || option.logo_url) && (
            <img
              className={classes.orImg}
              src={option.image_url || option.logo_url}
              alt={option.name}
            />
          )}
        </div>
        <div className={classes.orName}>{option.name}</div>
      </a>
    </div>
  );
};

export default FiltersRenderedOption;
